// Mock data for URBA-2C website

export const projectsGallery = [
  {
    id: 1,
    title: "Permis de construire - Villa",
    type: "Permis de construire",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/a86juguo_image%20PC%20A4.jpg",
    description: "Plans complets pour permis de construire"
  },
  {
    id: 2,
    title: "Déclaration préalable - Façade",
    type: "Déclaration préalable",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/e00nckti_DP-avant-apres3.jpg",
    description: "Rénovation de façade avec insertion avant/après"
  },
  {
    id: 3,
    title: "Déclaration préalable - Mur et clôture",
    type: "Déclaration préalable",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/uwkepmr6_mur%20cloture2.jpg",
    description: "Construction de mur de clôture"
  },
  {
    id: 4,
    title: "Certificat d'urbanisme",
    type: "Certificat d'urbanisme",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/xmwluqh0_image%20CU.jpg",
    description: "Certificat d'urbanisme opérationnel"
  },
  {
    id: 5,
    title: "Permis d'aménager",
    type: "Permis d'aménager",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/kw80zd3c_image%20PA.jpg",
    description: "Aménagement de parcelles"
  },
  {
    id: 6,
    title: "Permis de démolir",
    type: "Permis de démolir",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/1mqz2ism_image%20PD%C3%A9m.jpg",
    description: "Dossier de démolition"
  },
  {
    id: 7,
    title: "Assainissement non collectif",
    type: "Assainissement non collectif",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/kurzzp6y_image%20Assain.jpg",
    description: "Étude et plan d'assainissement"
  },
  {
    id: 8,
    title: "Maquette 3D - Permis de construire",
    type: "Permis de construire",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/5pwdrzab_image%203D%20PC.jpeg",
    description: "Modélisation 3D pour permis de construire"
  },
  {
    id: 9,
    title: "Agrandissement et aménagement d'une maison d'habitation",
    type: "Permis de construire",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/vnol649c_1-image%20PC2.jpg",
    description: "Plans d'agrandissement et aménagement"
  },
  {
    id: 10,
    title: "Modification extérieure - Ravalement",
    type: "Déclaration préalable",
    location: "Charente",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/j1ctpcae_propositions-facades-volets.jpg",
    description: "Ravalement de façades et changement de volets"
  }
];

export const permitTypes = [
  {
    id: 1,
    title: "Permis de construire",
    description: "Construction d'une maison individuelle et/ou ses annexes, travaux sur une construction existante, changement de destination d'un bâtiment.",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/a86juguo_image%20PC%20A4.jpg",
    cerfaLink: "https://www.service-public.fr/particuliers/vosdroits/R11637",
    cerfaDownload: "https://www.formulaires.service-public.fr/gf/cerfa_13406.do",
    characteristics: [
      "Construction de plus de 20m² d'emprise au sol",
      "Construction plancher de plus de 20m² de surface de plancher",
      "Modification de façade ou toiture",
      "Changement de destination"
    ]
  },
  {
    id: 2,
    title: "Déclaration préalable",
    description: "Travaux de petite importance (extension, modification d'aspect extérieur, division de terrain...) qui ne nécessitent pas de permis de construire.",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/e00nckti_DP-avant-apres3.jpg",
    cerfaLink: "https://www.service-public.fr/particuliers/vosdroits/R11646",
    cerfaDownload: "https://www.formulaires.service-public.fr/gf/cerfa_13703.do",
    characteristics: [
      "Extension entre 5m² et 20m²",
      "Modification d'aspect extérieur",
      "Changement de fenêtres",
      "Création d'ouverture"
    ]
  },
  {
    id: 3,
    title: "Certificat d'urbanisme",
    description: "Document d'information sur les règles d'urbanisme applicables à un terrain. Deux types : information (CUa) et opérationnel (CUb).",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/xmwluqh0_image%20CU.jpg",
    cerfaLink: "https://www.service-public.fr/particuliers/vosdroits/R1970",
    cerfaDownload: "https://www.formulaires.service-public.fr/gf/cerfa_13410.do",
    characteristics: [
      "CUa : informations générales",
      "CUb : faisabilité du projet",
      "Validité 18 mois",
      "Renseignements d'urbanisme"
    ]
  },
  {
    id: 4,
    title: "Permis d'aménager",
    description: "Obligatoire pour les aménagements de terrains (lotissements, campings, aires de stationnement...) selon leur importance.",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/kw80zd3c_image%20PA.jpg",
    cerfaLink: "https://www.service-public.gouv.fr/particuliers/vosdroits/R21378",
    cerfaDownload: "https://www.formulaires.service-public.fr/gf/cerfa_13409.do",
    characteristics: [
      "Lotissements",
      "Aires de stationnement",
      "Terrains de camping",
      "Parcs d'attractions"
    ]
  },
  {
    id: 5,
    title: "Permis de démolir",
    description: "Autorisation nécessaire pour démolir totalement ou partiellement une construction dans certaines communes.",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/1mqz2ism_image%20PD%C3%A9m.jpg",
    cerfaLink: "https://www.service-public.fr/particuliers/vosdroits/R1980",
    cerfaDownload: "https://www.formulaires.service-public.fr/gf/cerfa_13405.do",
    characteristics: [
      "Démolition totale ou partielle",
      "Secteurs protégés",
      "Délai d'instruction 2 mois",
      "Selon réglementation locale"
    ]
  },
  {
    id: 6,
    title: "Assainissement non collectif",
    description: "Autorisation pour l'installation ou la réhabilitation d'un système d'assainissement autonome (fosse septique, micro-station...).",
    image: "https://customer-assets.emergentagent.com/job_d46b51c3-4a6b-4717-9ad0-d85d730ee000/artifacts/kurzzp6y_image%20Assain.jpg",
    cerfaLink: "https://www.service-public.gouv.fr/particuliers/vosdroits/F447",
    cerfaDownload: "https://www.service-public.gouv.fr/particuliers/vosdroits/F447",
    characteristics: [
      "Installation neuve",
      "Réhabilitation système existant",
      "Contrôle SPANC obligatoire",
      "Respect normes en vigueur"
    ]
  }
];

export const contactFormSubmit = (formData) => {
  // Mock function - will be replaced with real API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted (mock):', formData);
      resolve({ success: true, message: 'Message envoyé avec succès!' });
    }, 1000);
  });
};